import { assertApiBaseUrl } from './env';

/**
 * APIの接続先。
 *
 * ADM-19。npm run build が react-scripts build の前に scripts/build-env.js で未設定・不正な URL・
 * 承認外の接続元を止める。ここでは、その検証を通らずに作られた成果物に備えて
 * 読み込み時にも確認する。productionでは例外にし、それ以外は記録して続行する。
 */
export const API_BASE_URL = assertApiBaseUrl(
  process.env.REACT_APP_API_URL,
  process.env.REACT_APP_ENVIRONMENT ?? process.env.NODE_ENV
);

export const PAGE_SIZE = 10;

/** サーバー側の max_page_size と同じ値。全件を読むときの1回あたりの上限。 */
export const MAX_PAGE_SIZE = 100;
